import { 
  NavigationMenu, 
  NavigationMenuContent, 
  NavigationMenuItem, 
  NavigationMenuLink, 
  NavigationMenuList, 
  NavigationMenuTrigger,
  navigationMenuTriggerStyle 
} from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { Menu } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import React from "react";

// Define the menu items with routes
const sections = [
  { name: "Home", href: "/" },
  { name: "Meet Your Coach", href: "/coach" },
  { name: "Accomplishments", href: "/accomplishments" },
  { name: "Programs", href: "/programs" },
  { name: "Testimonials", href: "/training-videos" },
  { name: "Register", href: "/register" },
];

const NavMenu = () => {
  const location = useLocation();

  return (
    <NavigationMenu className="hidden md:flex">
      <NavigationMenuList className="gap-1">
        {sections.map((section) => (
          <NavigationMenuItem key={section.name}>
            <Link 
              to={section.href}
              className={cn(
                navigationMenuTriggerStyle(),
                "bg-transparent hover:bg-primary/10 text-primary font-medium text-sm py-1.5 px-3",
                location.pathname === section.href && "bg-primary/10"
              )}
            >
              {section.name}
            </Link>
          </NavigationMenuItem>
        ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
};

// Mobile navigation dropdown
export const MobileNavMenu = () => {
  const location = useLocation();

  return (
    <div className="relative md:hidden">
      <NavigationMenu>
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger className="bg-transparent hover:bg-primary/10 text-primary font-medium p-1.5">
              <Menu size={24} />
            </NavigationMenuTrigger>
            <NavigationMenuContent className="w-[calc(100vw-2rem)] sm:w-80 right-0">
              <ul className="grid w-full gap-2 p-4">
                {sections.map((section) => (
                  <li key={section.name}>
                    <NavigationMenuLink asChild>
                      <Link
                        to={section.href}
                        className={cn(
                          "block select-none space-y-1 rounded-md p-2 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
                          location.pathname === section.href && "bg-accent"
                        )}
                      >
                        <div className="text-base font-medium leading-none">{section.name}</div>
                      </Link>
                    </NavigationMenuLink>
                  </li>
                ))}
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};

export default NavMenu;
